<template>
	<v-card 
		class="text-center mx-auto"
		:max-width="maxWidth"
		:width="width"
		flat
	>
		<v-card-item>
			<v-card-title :class="titleClass">
				{{ title }}
			</v-card-title>
			<v-card-subtitle :class="subtitleClass">
				{{ subtitle }}
			</v-card-subtitle>
		</v-card-item>
		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text>
			<v-form ref="form">
				<v-row dense>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.name"
							label="Прізвище, ім'я, по батькові"
							placeholder="Іваненко Іван Іванович"
							variant="outlined"
							:rules="[rules.required]"
							readonly
							@update:modelValue="item.changed=true"
							@keydown.ctrl.z="claim.ApplicantName='Іваненко Іван Іванович'"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<div class="text-left text-subtitle-2 font-weight-bold">Власник автомобіля {{ item.VehicleNumber }}</div>
						<div class="text-center">
							<v-radio-group v-model="claim.applicant.isOwner" inline
								@update:modelValue="item.changed=true"
							>
								<v-radio label="Так" :value="true"></v-radio>
								<v-radio label="Ні" :value="false"></v-radio>
							</v-radio-group>
						</div>
					</v-col>
					<!-- <v-col cols="12">
						<div class="text-left text-subtitle-2 font-weight-bold">Роль заявника</div>
						<div class="text-center">
							<v-radio-group v-model="claim.applicant.role.name" inline
								@update:modelValue="item.changed=true"
							>
								<v-radio label="Страхувальник" value="Страхувальник"></v-radio>
								<v-radio label="Потерпілий" value="Потерпілий"></v-radio>
							</v-radio-group>
						</div>
					</v-col> -->
					<v-col cols="12">
						<!-- <div class="text-left text-subtitle-2 font-weight-bold">Власник автомобіля {{ item.VehicleNumber }}</div> -->
						<div class="text-left text-subtitle-2 font-weight-bold">Тип особи власника</div>
						<div class="text-center">
							<v-radio-group v-model="claim.applicant.type.name" inline
								@update:modelValue="item.changed=true"
							>
								<v-radio label="фізична особа" value="фізична особа"></v-radio>
								<v-radio label="ФОП" value="ФОП"></v-radio>
								<v-radio label="юридична особа" value="юридична особа"></v-radio>
							</v-radio-group>
						</div>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.phone"
							label="Нормер телефону"
							placeholder="+38 ХХХ ХХХ ХХ ХХ"
							variant="outlined"
							readonly
							:rules="[rules.required,rules.phone]"
							@update:modelValue="item.changed=true"
							@keydown.ctrl.z="claim.applicant.phone='+380963332211'"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.address"
							label="Адреса проживання (для офіційного листування)"
							variant="outlined"
							@update:modelValue="item.changed=true"
							@keydown.ctrl.z="claim.applicant.address='Київ'"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<v-text-field
							v-model="claim.applicant.email"
							label="E-mail"
							placeholder="example@mail.com"
							variant="outlined"
							:rules="[rules.required,rules.email]"
							@update:modelValue="item.changed=true"
							@keydown.ctrl.z="claim.applicant.email='example@mail.com'"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<div class="text-left text-subtitle-2 font-weight-bold">Чи згодні Ви з обставинами настання ДТП, які були зафіксовані працівниками поліції (чи в Європротоколі)?</div>
						<div class="text-center">
							<v-radio-group v-model="claim.applicant.isAgreeCircumstances" inline
								@update:modelValue="item.changed=true"
							>
								<v-radio label="Так" :value="true"></v-radio>
								<v-radio label="Ні" :value="false"></v-radio>
							</v-radio-group>
						</div>
						<v-textarea v-if="!claim.applicant.isAgreeCircumstances"
							v-model="claim.applicant.disagreementReason"
							label="Причина незгоди"
							variant="outlined"
							rows="1"
							auto-grow
							@update:modelValue="item.changed=true"
						></v-textarea>
					</v-col>
					<v-col cols="12">
						<div class="text-left text-subtitle-2 font-weight-bold">Чи завдано шкоду життю чи здоров’ю учасникам події?</div>
						<div class="text-center">
							<v-radio-group 
								v-model="claim.applicant.isLifeHelthHarmed"
								inline
								@update:modelValue="item.changed=true"
							>
								<v-radio label="Так" :value="true"></v-radio>
								<v-radio label="Ні" :value="false"></v-radio>
							</v-radio-group>
						</div>
					</v-col>
					<v-col cols="12">
						<div class="text-left text-subtitle-2 font-weight-bold">Зазначте обставини настання ДТП</div>
						<div class="text-center">
							<v-textarea 
								v-model="claim.applicant.description"
								variant="outlined"
								:rules="[rules.required]"
								@update:modelValue="item.changed=true"
							></v-textarea>
						</div>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/main'

export default {
	name: 'Component::Applicant',
	mixins: [mixin],
}
</script>
